import React, { useState } from "react";

import { classnames, Icon } from "@culturehq/components";

const MinimalistAccordion = ({ className, initialOpen, children, upDown, coverRenderer }) => {
  const [state, setState] = useState({
    open: initialOpen
  });

  const handleToggle = () => {
    setState(prev => ({ ...prev, open: !prev.open }));
  };


  return (
    <div className={classnames("Accordian", "clearfix", state.open ? "open" : "", className)}>
      <div className="Accordian__container" onClick={handleToggle}>
        {coverRenderer}
        {upDown && <Icon className="Accordian__arrow" icon={state.open ? "chevron-up" : "chevron-down"} />}
      </div>

      <div className={classnames("Accordian__body", state.open ? "open" : "closed")}>
        {children}
      </div>
    </div>
  );
};

export default MinimalistAccordion;
